<template>
  <v-app id="search">
    <v-dialog
      :value="authModalShow && publicAuthEnabled"
      content-class="login-modal"
      :overlay-color="'#333'"
      :overlay-opacity="0.8"
      persistent
    >
      <Login
        v-if="authModalShow == 'LOGIN'"
        :dialogView="true"
        @close-modal="authModalShow = null"
        @show-register="authModalShow = 'REGISTER', fromLogin = true"
        @reset-password="authModalShow = 'RESETPASSWORD'"
      />
      <Register
        v-else-if="authModalShow == 'REGISTER'"
        :dialogView="true"
        :fromLogin="fromLogin"
        @close-modal="authModalShow = null, fromLogin = false"
        @show-login="authModalShow = 'LOGIN', fromLogin = false"
      />
      <ResetPassword
        v-else-if="authModalShow == 'RESETPASSWORD'"
        :dialogView="true"
        @close-modal="authModalShow = 'LOGIN'"
      />
    </v-dialog>
    <a
      class="white--text ml-auto mr-3 mt-3 signin-link d-block d-sm-none text-right"
      v-if="user"
    ><small>{{ userInfo }}</small><br/>
      <span class="v-underline" @click="logout"> Sign out ></span>
    </a>
    <a
      @click="login"
      class="
        v-underline
        ml-auto
        mr-3
        mt-3
        white--text
        signin-link
        d-block d-sm-none
      "
      v-else-if="publicAuthEnabled"
      >Sign in >
    </a>
    <router-view />
  </v-app>
</template>

<script>
import Login from "@/views/eldac-auth/Login";
import Register from "@/views/eldac-auth/Register";
import ResetPassword from "@/views/eldac-auth/ResetPassword";
import { mapActions, mapGetters } from "vuex";
import userInfoDisplayMixin from "@/mixins/userInfoDisplayMixin";
import publicAuthMixin from "@/mixins/publicAuthMixin";

export default {
  name: "Greetinglayout",

  mixins: [userInfoDisplayMixin, publicAuthMixin],

  components: {
    Login,
    Register,
    ResetPassword,
  },
  data() {
    return {
      fromLogin: false
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters(["authModal"]),
    authModalShow: {
      get() {
        return this.authModal;
      },
      set(val) {
        this.toggleAuthModal(val);
      },
    },
  },
  methods: {
    ...mapActions(["toggleAuthModal"]),
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      window.location.reload();
    },
    login() {
      this.toggleAuthModal("LOGIN");
    },
  },
};
</script>

<style lang="scss">
#search {
  background: #939597;
}

@media (max-width: 600px) {
  #search {
    background: #04748e;
    position: relative;
    .v-application--wrap {
      z-index: 1;
    }
  }

  #search::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-size: 500px 700px;
    background-position: -200px -200px;
    background-repeat: no-repeat;
    opacity: 0.6;
  }
}
</style>